import React, { Component } from "react";
import { Collapse } from "antd";
import styled from "styled-components";
import { connect } from 'react-redux';
import "./main.scss";

const { Panel } = Collapse;
class CalendarLegend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      widescreen: false,
    };
  }

  componentDidMount = async () => {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  };

  resize = () => {
    if (window.innerWidth >= 990) {
      this.setState({
        widescreen: true,
      });
    } else {
      this.setState({
        widescreen: false,
      });
    }
  };

  render() {
    return (
      <CalendarLegendWrapper color={this.props.theme ? '#444' : 'transparent'}>
        <Collapse>
          <Panel header="Calendar Legend">
            <div className="legend-container">
              <div className="legend-item">
                <div className="square approved-rdt">REG</div>
                <div className="legend-definition">
                  - Approved days which allow tour scheduling
                </div>
              </div>

              <div className="legend-item">
                <div className="square approved-dtr">OFF</div>
                <div className="legend-definition">- Approved days off</div>
              </div>

              <div className="legend-item">
                <div className="square unapproved-dtr">VAC</div>
                <div className="legend-definition">
                  - Requested days which are still unapproved
                </div>
              </div>

              <div className="legend-item">
                <div className="square ill-days">ILL</div>
                <div className="legend-definition">- Ill days</div>
              </div>

              <div className="legend-item">
                <div className="square busy-days">BUSY</div>
                <div className="legend-definition">- Busy days</div>
              </div>

              <div className="legend-item">
                <div
                  className="square more-info"
                  ref={(node) => {
                    if (node) {
                      node.style.setProperty("color", "red", "important");
                    }
                  }}
                >
                  REG
                </div>
                <div className="legend-definition">
                  - Day contains a comment
                </div>
              </div>
            </div>
          </Panel>
        </Collapse>
      </CalendarLegendWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    theme: state.navigation.theme
  }
}

export default connect(mapStateToProps,{})(CalendarLegend);

const CalendarLegendWrapper = styled.div`
  background-color: ${(props) => props.color} !important;
  
`;



// WEBPACK FOOTER //
// ./src/Components/DayType/CalendarLegend.js